// extracted by mini-css-extract-plugin
module.exports = {"search-touched":"search-touched__rLxtx","search-not-touched":"search-not-touched__QuwXs"};